import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import AboutPage from "./pages/AboutPage";
import CalculatorPage from "./pages/CalculatorPage";
import PrivacyPage from "./pages/PrivacyPage";
import { Toaster } from "./components/ui/sonner";

function CareersRedirect() {
  window.location.href = "https://www.notion.so/Careers-34215eb7f008808eb6b9c14a9fd10e24";
  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about-us" element={<AboutPage />} />
          <Route path="/debt-payoff-calculator" element={<CalculatorPage />} />
          <Route path="/privacy-policy" element={<PrivacyPage />} />
          <Route path="/careers" element={<CareersRedirect />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
